import { joinUrl, requestJson, type FetchLike } from './http';
import type { Manifest } from './types';

/** Cross-origin data plane; every call carries the short-lived data token. */
export function createDataApi(
  baseUrl: string,
  getToken: () => Promise<string>,
  fetchFn: FetchLike = (i, init) => fetch(i, init),
) {
  const channelPath = (channel: string, tail: string): string =>
    joinUrl(baseUrl, `v1/channels/${encodeURIComponent(channel)}/${tail}`);

  return {
    async getManifest(channel: string, signal?: AbortSignal): Promise<Manifest> {
      const token = await getToken();
      return requestJson<Manifest>(fetchFn, channelPath(channel, 'manifest'), {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'omit',
        ...(signal ? { signal } : {}),
      });
    },
    eventsUrl(channel: string): string {
      return channelPath(channel, 'events');
    },
  };
}

export type DataApi = ReturnType<typeof createDataApi>;
